import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../../Assets/Css/ReceivedAppointment.css";
import doctorImage from "../../Assets/Images/SVG/received-character.svg";

const ReceivedAppointment = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleHomeClick = () => {
    navigate("/home"); // Navigate to the home route
  };

  return (
    <div className="received-appointment-container">
      <img
        src={doctorImage}
        alt="Appointment Confirmation"
        className="received-appointment-image"
      />
      <div className="received-appointment-text">
        <h3>Your appointment request has been received</h3>
        <p>We’ll notify you as soon as it’s confirmed</p>
        <p>Thank you for your patience!</p>
      </div>
      <button
        className="received-appointment-home-button"
        onClick={handleHomeClick} // Add click handler
      >
        Home
      </button>
    </div>
  );
};

export default ReceivedAppointment;
